<div class=" border-0 px-4 py-1 scroll-container">
  <p class="page-title mt-3 fs-6 fw-bold">User Management</p>
  <div class="row">
    <div class="col-md-4">
      <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
        <div class="card-body d-flex align-items-center gap-3 py-3 px-3 justify-content-between">
          <!-- Text on the left -->
          <div class="d-flex flex-column justify-content-center text-start">
            <p class="mb-1 text-xs text-white">Users Created</p>
            <p class="m-0 fw-bold text-white">{{ users.length }}</p>
          </div>
          <!-- Icon on the right -->
          <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
            <i class="fas fa-users fa-lg text-primary-blue"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- New User Button -->
  <!-- User Table -->
  <div class="glassy-table rounded-lg border-0 mt-4 p-3">
      <div class="d-flex mb-2 justify-content-end">
        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#create_user">
          New User
        </button>
      </div>
      <GlobalTable
        v-if="users_list.length > 0"
        :headers="table_headers"
        :data="users_list"
        table_id="user-table">
        <template #actions="{ row }">
      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
      @click="edit_user(row)" data-bs-toggle="modal" data-bs-target="#edit_user">
      Edit
    </button>
    <button
      @click="select_user(row.user_id)"
      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
      data-bs-toggle="modal" data-bs-target="#assign_projects">
      Assign
    </button>
    <button
    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
    @click="open_log_modal(row)">
    Log
  </button>
      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="toggle_user_status(row)">
        {{ row.is_active ? 'Deactivate' : 'Activate' }}
      </button>

    </template>
      </GlobalTable>
  </div>
</div>

<!-- Create User Modal -->
 <teleport to="body">
<div class="modal fade" id="create_user" tabindex="-1" aria-labelledby="create_user_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_user_label">Create User</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="first_name" class="modal-form-label form-label text-xxs">First Name:</label>
          <input type="text" v-model="first_name" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x" placeholder="Enter First Name Here">
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a first name</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="last_name" class="modal-form-label form-label text-xxs">Last Name:</label>
          <input type="text" v-model="last_name" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x" placeholder="Enter Last Name Here">
          <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a last name</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="phone_number" class="modal-form-label form-label text-xxs">Phone Number:</label>
          <input
            type="text"
            v-model="phone_number"
            maxlength="10"
            @keypress="validate_numbers"
            oninput="this.value = this.value.replace(/\D/g, '')"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
            placeholder="Enter Phone Number Here"
          >
          <small
            v-if="phone_number && !validate_phone_number(phone_number)"
            class="text-danger p-2 text-xxs fw-bold d-block"
          >
            Please enter a valid 10-digit phone number
          </small>
          <small
            v-else
            class="text-danger p-2 text-xxs fw-bold d-none"
          >
            Please enter a valid phone number
          </small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="email" class="modal-form-label form-label text-xxs">Email:</label>
          <input type="text" v-model="email" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x" placeholder="Enter Email Here">
          <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a valid email address</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="user_role" class="modal-form-label form-label text-xxs">Role:</label>
          <select v-model="role" class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x">
              <option value="" disabled hidden>Select Role</option>
              <option v-for="role in user_roles" :key="role.id" :value="role.role">
                {{ role.role === 'Entity' ? 'Founder' : role.role }}
              </option>
          </select>

          <small class="text-danger p-2 text-xxs fw-bold d-none project-type-messages">Please select a role type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary-dark btn-sm px-3  text-xxs shadow-sm" @click="submit_user">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- edit modal -->
<teleport to="body">
<div class="modal fade" id="edit_user" tabindex="-1" aria-labelledby="edit_user_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="edit_user_label">Edit User</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="edit_first_name" class="modal-form-label form-label text-xxs">First Name</label>
          <input type="text" id="edit_first_name" v-model="edit_user_data.first_name"
                 class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
                 placeholder="Enter First Name">
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="edit_last_name" class="modal-form-label form-label text-xxs">Last Name</label>
          <input type="text" id="edit_last_name" v-model="edit_user_data.last_name"
                 class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
                 placeholder="Enter Last Name">
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="edit_email" class="modal-form-label form-label text-xxs">Email</label>
          <input type="text" id="edit_email" v-model="edit_user_data.email"
                 class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
                 placeholder="Enter Email">
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="edit_phone" class="modal-form-label form-label text-xxs">Phone Number</label>
          <input
            type="text"
            id="edit_phone"
            v-model="edit_user_data.phone_number"
            maxlength="10"
            @keypress="validate_numbers"
            oninput="this.value = this.value.replace(/\D/g, '')"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
            placeholder="Enter Phone Number"
          >
          <small
            v-if="edit_user_data.phone_number && !validate_phone_number(edit_user_data.phone_number)"
            class="text-danger p-2 text-xxs fw-bold d-block"
          >
            Please enter a valid 10-digit phone number
          </small>
          <small
            v-else
            class="text-danger p-2 text-xxs fw-bold d-none"
          >
            Please enter a valid phone number
          </small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="edit_role" class="modal-form-label form-label text-xxs">Role</label>
          <select id="edit_role" v-model="edit_user_data.role_id"
                  class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Role</option>
            <option v-for="role in user_roles" :key="role.id" :value="role.id">
              {{ role.role }}
            </option>
          </select>
        </div>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 text-xxs shadow-sm"
                @click="update_user">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Projects Modal -->
 <teleport to="body">
<div class="modal fade" id="assign_projects" tabindex="-1" aria-labelledby="assign_projects_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_projects_label">Assign Companies</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-body">
        <GlobalTable
          v-if="project_list.length > 0"
          :headers="project_headers"
          :data="project_list"
          :key="project_list"
          table_id="project_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.id"
                :checked="assigned_projects.includes(row.id)"
                @change="toggle_assignment(row.id)"
              >
              <label class="form-check-label" :for="'switch_' + row.id">
                {{ assigned_projects.includes(row.id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Log Modal -->
<!-- Modal for User Activity Logs -->
 <teleport to="body">
<div v-if="show_log_modal" class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header cute-header d-flex justify-content-center">

        <h6 class="modal-title text-center w-100 text-white">
          <i class="bi bi-clock-history me-2"></i> User Activity Logs
        </h6>
        <button type="button" class="modal-btn-close btn-close" @click="show_log_modal = false" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-4">

        <!-- Loading Spinner -->
        <div v-if="is_loading_logs" class="text-center py-3">
          <span class="spinner-border spinner-border-sm"></span>
          Loading logs...
        </div>

        <!-- Timeline Logs -->
        <div v-else>
          <div v-if="application_logs.length > 0">
            <ul class="list-unstyled position-relative ms-3">

              <li
                v-for="(log, index) in application_logs"
                :key="log.id"
                class="mb-4 position-relative ps-4 border-start timeline-log-item"
              >

                <!-- Timeline Dot with white tick/X -->
                <span
                  class="timeline-dot d-flex justify-content-center align-items-center"
                  :class="{
                    'bg-success': log.status === 'success',
                    'bg-danger': log.status === 'fail'
                  }"
                >
                  <i
                    class="bi text-white"
                    :class="log.status === 'success'
                      ? 'bi-check-lg'
                      : 'bi-x-lg'"
                  ></i>
                </span>

                <!-- Content -->
                <div class="bg-white p-3 rounded shadow-sm">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0">
                      {{ log.action }}
                    </h6>
                    <small class="text-muted">{{ log.timestamp }}</small>
                  </div>
                  <p class="mb-0 text-muted">{{ log.details }}</p>
                </div>

              </li>

            </ul>
          </div>

          <!-- No Logs Found -->
          <div v-else class="text-center text-muted">
            <i class="bi bi-journal-x fs-1"></i>
            <p>No logs found for this user.</p>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal Overlay (Backdrop) -->
<div v-if="show_log_modal" class="modal-backdrop fade show" @click="show_log_modal = false"></div>
</teleport>